import { createAsyncThunk } from "@reduxjs/toolkit";
import CompanyApi from "api/CompanyApi";

export const fetchCompany = createAsyncThunk(
  "fetchCompany",
  async ({ companyId }: { companyId: number }) => {
    return await CompanyApi.findOne(companyId);
  }
);
